import $ from 'jquery';
import * as CONST from '../../utils/constants';

const Tabs = CONST.globalProject.SelectedTabs;

class UpcomingEvents {
    constructor() {
    }

    init() {
        this.cards = $('.event-content.has-cta');

        this.cards.each((index, card) => {
            $(card).on('click', (event) => {
                event.preventDefault();
                const href = $(card).data('url');
                if (href) {
                    window.location.href = href;
                }
            });
        });
    }
}

export default UpcomingEvents;

$(() => {
    const upcomingEvents = new UpcomingEvents();
    setTimeout(() => { upcomingEvents.init(); }, 500);
});